import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import {
    getTcardBookingData,
    getTcardBranchData,
    getTcardData,
    postTCardCalendar_SetDayFull,
    postTCardMOTClose,
    postTCardsDragStatus,
    postTCardsDragStatusBookingDate
} from '../../../../Core/Service/TCardDashboard-service';
import moment from 'moment';
import AppContext from '../../../../App/AppContext';
import { AppStorage } from '../../../../Core/Service/storage-service';
import { useHistory } from 'react-router-dom';
import { createLogger } from '@microsoft/signalr/dist/esm/Utils';

export const TCaredBookingDashboardContext = createContext();

export const TCaredBookingDashboardProvider = (props) => {
    let calculateWidth = 'auto';
    const curretDate = moment();
    const portalSetting = AppStorage.getPortalSetting();
    let noOFDays = localStorage.getItem('userGridColumnTCardNoOfDays') || 7;
    const userGridColumnTCardNoOfDays = parseInt(noOFDays) > 0 ? parseInt(noOFDays) : 7;
    let checkIsTcardReadonly = localStorage.getItem('_isTcardReadonly_') === 'true' ? true : false;
    const history = useHistory();
    const { hideModal, showToast } = useContext(AppContext);
    const statusObject = AppStorage.getTCardStatus();
    const legendItems = [
        {
            label: portalSetting.portalSettingsCollectionDeliverText,
            background: portalSetting.portalSettingsCollectionDeliverBgColor || 'black',
            color: portalSetting.portalSettingsCollectionDeliverTextColor || 'white',
            st: 'cd'
        },
        {
            label: portalSetting.portalSettingsCustomerWaitingText,
            background: portalSetting.portalSettingsCustomerWaitingBgColor || 'black',
            color: portalSetting.portalSettingsCustomerWaitingTextColor || 'white',
            st: 'waiting'
        },
        {
            label: portalSetting.portalSettingsServiceText,
            background: portalSetting.portalSettingsServiceBgColor || 'black',
            color: portalSetting.portalSettingsServiceTextColor || 'white',
            st: 'service'
        },
        {
            label: portalSetting.portalSettingsInspectionText,
            background: portalSetting.portalSettingsInspectionBgColor || 'black',
            color: portalSetting.portalSettingsInspectionTextColor || 'white',
            st: 'inspection'
        },
        {
            label: portalSetting.portalSettingsMOTText,
            background: portalSetting.portalSettingsMOTBgColor || 'black',
            color: portalSetting.portalSettingsMOTTextColor || 'white',
            st: 'mot'
        },
        {
            label: portalSetting.portalSettingsRepairText,
            background: portalSetting.portalSettingsRepairBgColor || 'black',
            color: portalSetting.portalSettingsRepairTextColor || 'white',
            st: 'repair'
        },
        {
            label: portalSetting.portalSettingsNightShiftText,
            background: portalSetting.portalSettingsNightShiftBgColor || 'black',
            color: portalSetting.portalSettingsNightShiftTextColor || 'white',
            st: 'ns'
        },
        {
            label: portalSetting.portalSettingsRecallJobText,
            background: portalSetting.portalSettingsRecallJobBgColor || 'black',
            color: portalSetting.portalSettingsRecallJobTextColor || 'white',
            st: 'recall'
        },

        {
            label: portalSetting.portalSettingsTachoText,
            background: portalSetting.portalSettingsTachoBgColor || 'black',
            color: portalSetting.portalSettingsTachoTextColor || 'white',
            st: 'tacho'
        }
    ];

    const workType = AppStorage.getTCardWorkType();

    //Define state variables
    const [currentWeek, setCurrentWeek] = useState(moment());
    const [weekList, setWeekList] = useState([]);
    const [loader, setLoader] = useState(true);
    const [status, setStatus] = useState(JSON.parse(statusObject));
    const [updatedStatus, setUpdatedStatus] = useState([]);
    const [col2, setCol2] = useState({});
    const [temp, setTemp] = useState({
        name: '',
        list: [],
        open: false
    });
    const [tCardList, setTCardList] = useState({
        bookingConfirmed: [],
        startDate: moment(),
        waitingStart: [],
        noShow: [],
        motPrep: [],
        inProg: [],
        awaitingCallBack: [],
        partOrder: [],
        recall: [],
        branchID: '',
        toSchedule: [],
        tCardID: null,
        tCardSelectedColor: '',
        tCardStatus: [],
        allocatedHours: [],
        usersHoliday: [],
        tpNames: [],
        closeDays: [],
        calculateWidth: 'auto',
        MotCloseMSg: ''
    });
    const initialStart = moment().startOf('isoWeek').format('YYYY-MM-DD');
    const initialEnd = moment().startOf('isoWeek').add(userGridColumnTCardNoOfDays > 0 ? userGridColumnTCardNoOfDays - 1 : 5, 'days').format('YYYY-MM-DD');
    const [Start, setStart] = useState(initialStart);
    const [openModal, setOpenModal] = useState(false);
    const [closeDayModal, setCloseDayModal] = useState(false);
    const [userHolidayModal, setUserHolidayModal] = useState(false);
    const [motClose, setMotClose] = useState(false);
    const [End, setEnd] = useState(initialEnd);
    const [branchList, setBranchList] = useState([]);
    const [customers, setCustomer] = useState([]);
    const [selectedDate, setSelectedDate] = useState(null);
    const [fullScreen, setFullScreen] = useState(false);
    const [count, setCount] = useState(0);
    const [expand, setExpand] = useState({});
    const [filterTcard, setFilterTcard] = useState({});
    const [motFields, setMotFields] = useState({
        branchID: tCardList.branchID,
        isClosed: true,
        date: moment().format('YYYY-MM-DD'),
        motMessage: ''
    });

    const [workTypeArray] = useState(JSON.parse(workType) || []);

    const [filters, setFilters] = useState({
        regNo: '',
        cust: ''
    });

    const ShowAllTcards = (cond, name, list) => {
        setTemp((st) => ({ ...st, open: cond, name: name, list: list }));
    };
    const handleMOT = (dt, flag, catID) => {
        setMotClose(true);
        setMotFields((st) => ({
            ...st,
            isMotClose: flag,
            branchID: tCardList.branchID,
            isClosed: !flag,
            catID: catID,
            date: moment(dt).format('YYYY-MM-DD'),
            motMessage: !flag
                ? `Do you want to mark ${moment(dt).format('YYYY-MM-DD')} as MOT closed?`
                : `MOT is closed for ${moment(dt).format('YYYY-MM-DD')} , do you want to allow MOT on this day?`
        }));
    };
    const handleCloseMOT = () => {
        setMotClose(false);
    };
    const handleExpand = (name, value) => {
        setExpand((st) => ({ ...st, [name]: value }));
    };
    const handleRecallExpand = (name, value) => {
        setExpand((st) => ({ ...st, [name]: value }));
    };
    const handleTcardOpen = (cond, id, res, color) => {
        setOpenModal(cond);
        setTCardList((state) => ({
            ...state,
            tCardID: id,
            tCardSelectedColor: color
        }));

        res && fetchData();
    };
    const handlePlusButtonClick = (id) => {
        setSelectedDate(id);
        setCloseDayModal(true);
    };
    const handleCloseDayModal = (res) => {
        setSelectedDate(null);
        setCloseDayModal(false);
        res && fetchData();
    };
    const handleCalendarButtonClick = (date) => {
        setSelectedDate(moment(date).format('YYYY-MM-DD'));
        setUserHolidayModal(true);
    };
    const handleUserHolidayModal = (res) => {
        setSelectedDate(null);
        setUserHolidayModal(false);
        res && fetchData();
    };
    const handleFullScreen = (cond) => {
        setFullScreen(!fullScreen);
    };
    const fetchData = useCallback(async () => {
        setLoader(true);
        if (tCardList.branchID) {
            let res = await getTcardBookingData(tCardList.branchID, Start, End);
            if (res.success) {
                let data = res.data.tCards;
                let bookingConfirmed = res.data.tCards?.filter((k) => k.tCardsID !== null && status !== null) || [];
                let allocatedHours = res.data.allocatedHours;
                let usersHoliday = res?.data?.usersHoliday;
                let closeDays = res?.data?.openDays || [];

                calculateWidth = 100 / (3 + closeDays.length);

                let tempList = data.filter((k) => k.status === 'RECALL');

                let tpNames = new Set(data.map((k) => k.tp));

                setTCardList((st) => ({
                    ...st,
                    bookingConfirmed: bookingConfirmed,
                    tCardStatus: data || [],
                    allocatedHours: allocatedHours,
                    tpNames: Array.from(tpNames),
                    closeDays: closeDays,
                    closeDaysSat: closeDays.filter(({ dt }) => moment(dt).day() == 6),
                    recall: tempList,
                    usersHoliday: usersHoliday,
                    calculateWidth: calculateWidth
                }));

                setFilterTcard((st) => ({
                    ...st,
                    bookingConfirmed: bookingConfirmed,
                    tCardStatus: data || [],
                    allocatedHours: allocatedHours,
                    tpNames: Array.from(tpNames),
                    closeDays: closeDays,
                    recall: tempList,
                    usersHoliday: usersHoliday,
                    calculateWidth: calculateWidth
                }));

                setLoader(false);
            }
        }
    }, [tCardList.branchID, Start, End]);

    function shortListByTrailter(data, label) {

        console.log('shortListByTrailter called with label:', label, data);
        const arr = [...data];
        arr.sort((a, b) => {
            if (!a.trailer && b.trailer) return -1;
            if (a.trailer && !b.trailer) return 1;
            return 0;
        });

        const result = [];
        const used = new Set();

        for (const item of arr) {
            if (used.has(item.tCardsID)) continue;

            result.push(item);
            used.add(item.tCardsID);

            const trailerMatches = arr.filter((x) => !used.has(x.tCardsID) && x.trailer === item.reg);

            trailerMatches.forEach((m) => {
                result.push(m);
                used.add(m.tCardsID);
            });
        }

        return result;
    }

    console.log(tCardList, 'tCardList');
    const handleChange = (e) => {
        const branchID = e.target.value;
        const tempObj = branchList.find((k) => k.id == branchID);

        if (tempObj) {
            const branchName = tempObj.name;
            const tempData = {
                ...JSON.parse(localStorage.getItem('_dashboard_') || '{}'),
                BranchBytime: branchName,
                selectedValueByTech: branchName,
                BranchPartReq: branchName,
                branchShortName: branchName
            };
            localStorage.setItem('_dashboard_', JSON.stringify(tempData));

            const btTimeData = {
                ...JSON.parse(localStorage.getItem('FiltterParams') || '{}'),
                branchShortName: branchName
            };
            localStorage.setItem('FiltterParams', JSON.stringify(btTimeData));
        }

        // Always run state updates
        setLoader(true);
        setTCardList((prev) => ({
            ...prev,
            branchID
        }));
    };

    const [dayFull, setDayFull] = useState({
        date: null,
        show: false,
        mode: 'set' // 'set' or 'open'
    });

    const handletSetDayFull = (dt, mode) => {
        setDayFull({
            date: dt,
            mode: mode,
            show: true
        });
    };

    const handletCloseSetDayFull = (dt) => {
        setDayFull({
            date: null,
            show: false
        });
    };

    const submitTcardLock = async (dt) => {
        let data = {
            isDayFull: dayFull.mode == 'set' ? true : false,
            branchID: tCardList.branchID,
            date: moment(dayFull.date).format('YYYY-MM-DD')
        };

        let res = await postTCardCalendar_SetDayFull(data);

        if (res.success) {
            // showToast(`T-card day ${moment(dt).format('YYYY-MM-DD')} is now locked successfully`);
            showToast(res.data.message);
            handletCloseSetDayFull();
            fetchData();
        }
    };

    const changeWeek = (direction) => {
        const dates = tCardList.closeDays
            .map(({ dt }) => new Date(dt))
            .filter((d) => !isNaN(d.getTime()));
        const maxDate = dates.length ? new Date(Math.max(...dates)) : new Date();
        const minDate = dates.length ? new Date(Math.min(...dates)) : new Date();
        const daysCount = userGridColumnTCardNoOfDays > 0 ? userGridColumnTCardNoOfDays - 1 : 5;

        if (direction === 'next') {
            setCount((prevCount) => prevCount + 1);
            setCurrentWeek((prevWeek) => {
                const newStartDate = moment(maxDate).add(1, 'day').format('YYYY-MM-DD');
                const newEndDate = moment(newStartDate).add(daysCount, 'days').format('YYYY-MM-DD');

                setStart(newStartDate);
                setEnd(newEndDate);
                return moment(newStartDate);
            });
        } else if (direction === 'prew') {
            setCount((prevCount) => prevCount - 1);
            setCurrentWeek((prevWeek) => {
                const newEndDate = moment(minDate).subtract(1, 'day').format('YYYY-MM-DD');
                const newStartDate = moment(newEndDate).subtract(daysCount, 'days').format('YYYY-MM-DD');

                setStart(newStartDate);
                setEnd(newEndDate);
                return moment(newStartDate);
            });
        }

        setLoader(true);
    };

    const handleCurrentWeek = useCallback(() => {
        setLoader(true);
        setCount(0);
        const newWeek = moment().startOf('isoWeek');
        const daysCount = userGridColumnTCardNoOfDays > 0 ? userGridColumnTCardNoOfDays - 1 : 5;
        const newStartDate = newWeek.format('YYYY-MM-DD');
        const newEndDate = newWeek.clone().add(daysCount, 'days').format('YYYY-MM-DD');

        setCurrentWeek(newWeek);
        setStart(newStartDate);
        setEnd(newEndDate);
        setLoader(false);
    }, [userGridColumnTCardNoOfDays]);

    const reset = useCallback(() => {
        setLoader(true);
        setCount(0);
        const newWeek = moment().startOf('isoWeek');
        const daysCount = userGridColumnTCardNoOfDays > 0 ? userGridColumnTCardNoOfDays - 1 : 5;
        const newStartDate = newWeek.format('YYYY-MM-DD');
        const newEndDate = newWeek.clone().add(daysCount, 'days').format('YYYY-MM-DD');

        setCurrentWeek(newWeek);
        setStart(newStartDate);
        setEnd(newEndDate);
        setLoader(false);
    }, [userGridColumnTCardNoOfDays]);

    useEffect(() => {
        if (filters.cust) {
            handleFilter(filters.cust, 'cust');
        }
        if (filters.regNo) {
            handleFilter(filters.regNo, 'reg');
        }
    }, [filters.cust, filters.regNo, filterTcard]);

    const handleFilter = (value, key) => {
        let searchValue = value.toLowerCase();

        let { bookingConfirmed = [], tCardStatus = [], recall = [] } = filterTcard;

        const filterByKey = (data) => data.filter((item) => item[key]?.toLowerCase().includes(searchValue));

        setTCardList((prev) => ({
            ...prev,
            bookingConfirmed: filterByKey(bookingConfirmed),
            tCardStatus: filterByKey(tCardStatus),
            recall: filterByKey(recall)
        }));
    };

    const handleCustomerFilter = (e) => {
        let { value } = e.target;
        localStorage.setItem('_TcardCustValue_', value);
        setFilters((st) => ({ ...st, cust: value }));
        handleFilter(value, 'cust');
    };

    const handleRegNoFilter = (e) => {
        let { value } = e.target;
        localStorage.setItem('_TcardRegValue_', value);
        handleFilter(value, 'reg');
        setFilters((st) => ({ ...st, regNo: value }));
    };

    function getWeekNumber(dateStr) {
        if (!dateStr) return 'No Date';

        const date = new Date(dateStr);
        if (isNaN(date.getTime())) return 'Invalid Date';

        const tempDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
        const dayNum = tempDate.getUTCDay() || 7;
        tempDate.setUTCDate(tempDate.getUTCDate() + 4 - dayNum);
        const yearStart = new Date(Date.UTC(tempDate.getUTCFullYear(), 0, 1));
        const weekNo = Math.ceil(((tempDate - yearStart) / 86400000 + 1) / 7);
        return `Week ${weekNo} `;
    }

    const toBeScheduledCards = (data) => {
        const list = data.filter((item) => item.status === 'TO BE SCHEDULED' && item.dd);

        const groupedByWeek = list.reduce((acc, card) => {
            const week = getWeekNumber(card.dd);
            if (!acc[week]) acc[week] = [];
            acc[week].push(card);
            return acc;
        }, {});
        return Object.entries(groupedByWeek || {});
    };

    const submitMotClose = async () => {
        let data = {
            // branchID: motFields.branchID,
            isClosed: motFields.isClosed,
            TCardCalendarID: motFields.catID
        };
        let res = await postTCardMOTClose(data);
        if (res.success) {
            setMotClose(false);
            showToast(`MOT closed for ${moment(motFields.date).format('YYYY-MM-DD')} successfully`);
            fetchData();
        } else {
            console.error(res);
            showToast('Error closing MOT');
        }
    };

    const handleDragForBooking = async (bookingData, res) => {
        const bookingUpdate = await postTCardsDragStatusBookingDate(bookingData);
        if (!bookingUpdate.success) {
            showToast('Booking or status update failed');
        } else {
            res && setLoader(true);
            res && fetchData();
        }
    };

    const updateCardStatus = async (statusData, destId) => {
        const res = await postTCardsDragStatus(statusData);
        if (res.success) {
            showToast(`T-card moved to ${destId} successfully`);
            setLoader(true);
            fetchData();
        } else {
            showToast(`Failed to Move status to '${destId}'`);
        }
    };

    function parseScheduledWeek(input) {
        // Remove optional hyphen and "Week", then normalize spaces
        const cleaned = input.replace(/-?\s*Week\s*/i, ' ').trim();
        const parts = cleaned.split(/\s+/); // split by any whitespace

        // Separate text and numeric part
        const textPart = parts.slice(0, -1).join(' ');
        const numberPart = parts.slice(-1)[0];

        return [textPart, numberPart];
    }

    const handleDragEnd = async (result) => {
        const { source, destination, draggableId } = result;

        if (!destination || (source.droppableId === destination.droppableId && destination.index === source.index)) return;

        try {
            const array = JSON.parse(statusObject);
            const destId = destination.droppableId;
            const sourceId = source.droppableId;
            const isToBeScheduled = destId.includes('TO BE SCHEDULED');
            const match = destId.match(/^([\d]{4}-[\d]{2}-[\d]{2})-(.+)$/);
            const newNightShift = sourceId?.match(/^([\d]{4}-[\d]{2}-[\d]{2})-(.+)$/);

            const isSChedule = parseScheduledWeek(sourceId);
            const isDestSChedule = parseScheduledWeek(destId);

            let isFromNightShift = newNightShift && ['ns', 'cd-ns'].includes(newNightShift[2]);

            if (isFromNightShift && !match) {
                const nightShiftData = {
                    tCardsIsNightShift: false,
                    tCardsID: +draggableId
                };

                handleDragForBooking(nightShiftData);
            } else if (match) {
                const [_, date, type] = match;
                const ns = ['ns', 'cd-ns'].includes(type);
                const cd = ['cd', 'cd-ns'].includes(type);

                const checkStatusForNight = !ns || (ns && (sourceId === 'RECALL' || isSChedule[0] === 'TO BE SCHEDULED'));

                const bookingData = {
                    tCardsIsNightShift: ns,
                    tCardsID: +draggableId,
                    tCardsBookingDate: moment(date).format('YYYY-MM-DD'),
                    tCardsIsCollectionDeliver: cd,
                    tCardsIsRecallJob: false
                };

                handleDragForBooking(bookingData, !checkStatusForNight ? true : false);

                if (checkStatusForNight)
                    updateCardStatus(
                        {
                            tCardsStatusID: 1,
                            tCardsID: +draggableId
                        },
                        destId
                    );
            }

            if (isDestSChedule[0] === 'TO BE SCHEDULED') {
                setLoader(true);
                const statusObj = array.find((k) => k.status === 'TO BE SCHEDULED');
                if (!statusObj) throw new Error('Status not found');
                updateCardStatus(
                    {
                        tCardsStatusID: statusObj.id,
                        tCardsID: +draggableId
                    },
                    destId
                );
                return;
            }
            setLoader(true);

            const targetStatus = destId;
            const statusObj = array.find((k) => k.status === targetStatus);
            if (!statusObj) throw new Error('Status not found');

            updateCardStatus(
                {
                    tCardsStatusID: statusObj.id,
                    tCardsID: +draggableId
                },
                destId
            );
        } catch (error) {
            console.error('Drag error:', error);
            // showToast(`T-card move failed: ${error.message}`);
        }
    };

    useEffect(() => {
        if (!portalSetting?.portalSettingGridRefreshTime || isNaN(portalSetting.portalSettingGridRefreshTime)) {
            console.error('Invalid portalSettingGridRefreshTime:', portalSetting?.portalSettingGridRefreshTime);
            return;
        }

        const RefreshTime = portalSetting.portalSettingGridRefreshTime * 1000;

        const interval = setInterval(() => {
            try {
                fetchData(); // if fetchData is async, you can wrap it in an IIFE
            } catch (error) {
                console.error('Error while fetching data:', error);
            }
        }, RefreshTime);

        return () => clearInterval(interval);
    }, [fetchData, portalSetting?.portalSettingGridRefreshTime]);

    useEffect(() => {
        const runFetch = () => {
            try {
                fetchData(); // if fetchData is async
            } catch (error) {
                console.error('Error in fetchData:', error);
            }
        };

        runFetch();
    }, [fetchData]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const res = await getTcardBranchData();

                if (res?.success && Array.isArray(res.data?.branches)) {
                    const branches = res.data.branches;
                    const customer = res.data.customers;

                    setBranchList(branches);
                    setCustomer(customer);

                    let dashboardData = {};
                    try {
                        dashboardData = JSON.parse(localStorage.getItem('_dashboard_') || '{}');
                    } catch (e) {
                        console.warn('Invalid JSON in _dashboard_ localStorage:', e);
                    }

                    const selectedBranchName = dashboardData.BranchPartReq;
                    const matchedBranch = branches.find((b) => b.name === selectedBranchName);
                    const fallbackBranchID = branches[0]?.id || null;

                    setTCardList((prev) => ({
                        ...prev,
                        branchID: matchedBranch?.id || fallbackBranchID
                    }));
                } else {
                    console.error('Failed to fetch valid branch data:', res);
                }
            } catch (error) {
                console.error('Error fetching TCard branch data:', error);
            }
        };

        fetchData();
    }, []);

    useEffect(() => {
        try {
            const weekList = Array.isArray(tCardList?.closeDays) ? tCardList.closeDays : [];
            setWeekList(weekList);
        } catch (error) {
            console.error('Failed to set week list from tCardList:', error);
            setWeekList([]); // Fallback to empty list
        }
    }, [currentWeek, End, Start, tCardList]);

    useEffect(() => {
        try {
            // Filter out '0-0' status
            const filterStatus = Array.isArray(status) ? status.filter((k) => k?.tCardStatusequence !== '0-0') : [];

            // Group items by row based on tCardStatusequence
            const groupedByRow = filterStatus.reduce((acc, item) => {
                const [column, row] = item?.tCardStatusequence?.split('-') || [];

                if (!row) return acc;

                if (!acc[row]) acc[row] = [];
                acc[row].push(item);
                return acc;
            }, {});

            // Find the specific status with sequence '2-1'
            const find2ndCol = status?.find((k) => k?.tCardStatusequence === '2-1');
            setCol2(find2ndCol);

            // Create 2-item pairs for each row
            const cleanedArray = Object.values(groupedByRow).flatMap((rowItems) => {
                const pairs = [];
                for (let i = 0; i < rowItems.length; i += 2) {
                    const pair = [rowItems[i]];
                    if (rowItems[i + 1]) pair.push(rowItems[i + 1]);
                    pairs.push(pair);
                }
                return pairs;
            });

            setUpdatedStatus(cleanedArray);
        } catch (error) {
            console.error('Error in processing status:', error);
            setUpdatedStatus([]);
        }
    }, [status]);

    // Resolve the MOT card colour from the work type list by matching motWorkTypeID
    // (the id the backend sends on the card against the same id in the work type list).
    const setMotColor = (id, isColor) => {
        try {
            if (workTypeArray.length > 0) {
                const obj = workTypeArray.find((j) => id != null && String(j.motWorkTypeID) === String(id));

                if (obj) {
                    return isColor ? obj.tc ?? 'black' : obj.bgc ?? '';
                }
            }
            return isColor ? 'black' : '';
        } catch (error) {
            console.error('setMotColor error:', error);
            return isColor ? 'black' : '';
        }
    };

    return (
        <TCaredBookingDashboardContext.Provider
            value={{
                fullScreen,
                loader,
                tCardList,
                legendItems,
                handleCustomerFilter,
                handleRegNoFilter,
                handleFullScreen,
                checkIsTcardReadonly,
                history,
                handleCurrentWeek,
                reset,
                handleChange,
                branchList,
                curretDate,
                handlePlusButtonClick,
                changeWeek,
                count,
                handleDragEnd,
                updatedStatus,
                toBeScheduledCards,
                portalSetting,
                expand,
                handleExpand,
                handleTcardOpen,
                handleCalendarButtonClick,
                handleMOT,
                openModal,
                closeDayModal,
                setCloseDayModal,
                selectedDate,
                handleCloseDayModal,
                temp,
                ShowAllTcards,
                userHolidayModal,
                setUserHolidayModal,
                handleUserHolidayModal,
                motClose,
                handleCloseMOT,
                motFields,
                submitMotClose,
                filters,
                submitTcardLock,
                dayFull,
                handletSetDayFull,
                handletCloseSetDayFull,
                workType,
                shortListByTrailter,
                setMotColor
            }}
        >
            {props.children}
        </TCaredBookingDashboardContext.Provider>
    );
};
